import { render, staticRenderFns } from "./Lable.vue?vue&type=template&id=8333a92e&scoped=true&"
import script from "./Lable.vue?vue&type=script&lang=js&"
export * from "./Lable.vue?vue&type=script&lang=js&"
import style0 from "./Lable.vue?vue&type=style&index=0&id=8333a92e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8333a92e",
  null
  
)

export default component.exports